import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import SellerLedgerService from "../services/SellerLedgerService";

export const SellerLedgerContext = createContext("SellerLedgerContext");

const SellerLedgerContextProvider = ({ children }) => {
	const [sellerLedgerList, setSellerLedgerList] = useState([]);
	const [loadingSellerLedgerList, setLoadingSellerLedgerList] =
		useState(false);
	const [sellerLedgerListErrorMsg, setSellerLedgerListErrorMsg] =
		useState("");
	const [totalElements, setTotalElements] = useState(0);

	const getSellerLedgerList = async (id, params) => {
        setLoadingSellerLedgerList(true);
		try {
			setSellerLedgerListErrorMsg("");
			const response = await SellerLedgerService.getSellerLedgerList(
				id,
				params,
			);
			setSellerLedgerList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
            const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setSellerLedgerListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingSellerLedgerList(false);
        }
	};

	return (
		<SellerLedgerContext.Provider
			value={{
				getSellerLedgerList,
				sellerLedgerList,
				totalElements,
				loadingSellerLedgerList,
				sellerLedgerListErrorMsg,
			}}
		>
			{children}
		</SellerLedgerContext.Provider>
	);
};

export default SellerLedgerContextProvider;
